import scrollLock from 'scroll-lock';
import View from '../view/view';
import mitt from 'mitt';
import uniqueId from '../../scripts/helpers/uniqueId';

class Controller {
	constructor() {
		this.events = mitt();

		this.touch = "ontouchend" in document;

		this.svgIconId = uniqueId('svg-icon-id-');

		this.passiveEventsSupported = (() => {
			// passive event listeners support test from MDN
			let result = false;
			try {
				window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
					get: () => result = true
				}));
			} catch (err) {}
			return result;
		})();

		this.mobileNavData = [];

		document.addEventListener('keydown', (e) => {
			if (e.keyCode === 27) {
				this.closeAll();
			}
		});

		document.querySelector('.js-overlay').addEventListener('click', () => {
			this.closeAll();
		});

		View.initAllGlobal();
		View.initAllLocal(document.body);
	}

	lockScrolling($el) {
		scrollLock.clearQueueScrollLocks();
		const $fillGapElement = document.querySelector('.page-header-wrap');
		if ($fillGapElement) {
			scrollLock.addFillGapTarget($fillGapElement);
		}
		const $fillGapElement2 = document.querySelector('.catalog__filter-panel--sticky');
		if ($fillGapElement2) {
			scrollLock.addFillGapTarget($fillGapElement2);
		} else {
			scrollLock.removeFillGapTarget(document.querySelector('.catalog__filter-panel'));
		}
		scrollLock.disablePageScroll($el ? $el : document.querySelectorAll('.modal__surface'));
	}

	unlockScrolling($el) {
		scrollLock.enablePageScroll($el ? $el : document.querySelectorAll('.modal__surface'));
	}

	openMobileNav() {
		this.events.emit('mobile-nav-open');
	}

	closeMobileNav() {
		this.events.emit('mobile-nav-close');
	}

	updateMobileNav(data) {
		this.mobileNavData.push(data);
		this.events.emit('mobile-nav-updated', this.mobileNavData);
	}

	openSearchSmall() {
		this.events.emit('search-small-open');
	}

	closeSearchSmall() {
		this.events.emit('search-small-close');
	}

	emitCustomEvent(eventname, response) {
		this.events.emit(eventname, response);
	}

	openModal(options) {
		if (window.modalController) {
			window.modalController.open(options);
		}
	}

	clickVideo(indexNumber) {
		this.events.emit('click-video', indexNumber);
	}

	emitFieldTelAccept(isInputComplete) {
		this.events.emit('field-tel-accept', isInputComplete);
	}

	closeModal() {
		if (window.modalController) {
			window.modalController.close();
		}
	}

	openFilter() {
		this.events.emit('open-filter');
	}

	openField(id) {
		this.events.emit('open-field', id);
	}

	closeAllModals() {
		if (window.modalController) {
			window.modalController.closeAll();
		}
	}

	closeAll() {
		this.closeMobileNav();
		this.closeMobileNav();
		this.closeSearchSmall();
		this.closeAllModals();
	}

	updateModelSource(dataType) {
		this.events.emit('update-model-source', dataType);
	}

	addNotification(data) {
		this.events.emit('add-notification', data);
	}
	
	changeColor(field) {
		this.events.emit('change-color', field);
	}
}

export default new Controller();